import React from "react";
import { DialogComponent } from "../../DialogComponent/DialogComponent";
import { DialogContentText, Link } from "@material-ui/core";
import { useLayoutDetection } from "../../../Hooks";
import { CustomDialog } from "../../V2";

const BrightCallAppAlertDialog = ({ open, onClose, onConfirm }) => {
  const onSubmit = () => {
    onClose();
  };

  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();

  const isNewLayout = hasNewLayout && isReskinningLayout;

  if (isNewLayout) {
    return (
      <CustomDialog
        open={open}
        onClose={onClose}
        showActions={false}
        title={"Brightcall - No App found"}
        content={
          <DialogContentText className="text-center texts gray-primary-bold">
            The BrightCall app is not installed on your device. Please install
            the app to make calls directly from the platform.
            <br />
            <Link
              href="https://help.brightcall.ai/en/articles/8615009-installing-dialer-on-mac-windows"
              target="_blank"
              rel="noopener noreferrer"
              onClick={onSubmit}
            >
              Click here to install the BrightCall app.
            </Link>
          </DialogContentText>
        }
      />
    );
  }

  return (
    <DialogComponent
      titleText={"Brightcall - No App found"}
      isOpen={open}
      onCloseClicked={onClose}
      maxWidth={"sm"}
      dialogContent={
        <DialogContentText className="text-center texts gray-primary-bold">
          The BrightCall app is not installed on your device. Please install the
          app to make calls directly from the platform.
          <br />
          <Link
            href="https://help.brightcall.ai/en/articles/8615009-installing-dialer-on-mac-windows"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onSubmit}
          >
            Click here to install the BrightCall app.
          </Link>
        </DialogContentText>
      }
    />
  );
};
export default BrightCallAppAlertDialog;
